var _excluded = ["logo"],
    _excluded2 = ["id"],
    _excluded3 = ["adiInstanceId", "version"],
    _excluded4 = ["page", "filter"];
import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { wait } from '../utils/promises';
import urlJoin from 'url-join';
import queryString from 'query-string';
import { castArray, chunk } from 'lodash';
import { validate } from 'uuid';
import { ParameterBuilder } from '../utils/ParameterBuilder';
export var DEFAULT_PAGE_LIMIT = 100;
export var TEMPLATES_LIMIT = 200;
export var DEFAULT_LOGOS_PER_PAGE = 100;

function logoDisplaysTransformer(logoDisplays) {
  return logoDisplays.map(function (logoObj) {
    var logo = logoObj.logo,
        rest = _objectWithoutPropertiesLoose(logoObj, _excluded);

    var id = logo.id,
        logoRest = _objectWithoutPropertiesLoose(logo, _excluded2);

    return _objectSpread(_objectSpread(_objectSpread({}, rest), logoRest), {}, {
      logo: logo,
      logoId: id
    });
  });
}

export var LogoWebAppApi = /*#__PURE__*/function () {
  function LogoWebAppApi(httpClient, iconsUrlHttpClient, options) {
    var _this = this;

    if (options === void 0) {
      options = {};
    }

    _defineProperty(this, "hasUnlimitedEdits", function (userId) {
      return _this.get("/v1/admin/" + userId + "/has-unlimited-edits");
    });

    this._httpClient = httpClient;
    this.iconsUrlHttpClient = iconsUrlHttpClient;
    this.cache = {};
    this.entitiesCache = [];
    this._options = options;
  }

  var _proto = LogoWebAppApi.prototype;

  _proto._validateLogoId = function _validateLogoId(logoId, from) {
    if (from === void 0) {
      from = '';
    }

    if (!logoId) {
      throw new Error("logoId is missing from " + from);
    } else if (!validate(logoId)) {
      throw new Error("logoId is invalid " + logoId);
    }
  };

  _proto._validateEntityId = function _validateEntityId(entityId, from) {
    if (!entityId || entityId === '') {
      throw new Error("entityId is missing from " + from);
    }
  };

  _proto.get = function get(path) {
    return this._httpClient.get(path).then(function (response) {
      return response.data;
    });
  };

  _proto.createLayout = function createLayout(layout) {
    return this._httpClient.post('/v2/layouts', {
      layout: layout
    }).then(function (response) {
      return response.data.layoutId;
    });
  };

  _proto.updateLayout = function updateLayout(layout) {
    return this._httpClient.put('/v2/layouts/' + layout.id, {
      layout: layout
    }).then(function (response) {
      return response.data;
    });
  };

  _proto.getLayout = function getLayout(layoutId) {
    return this._httpClient.get('/v2/layouts/' + layoutId).then(function (response) {
      return response.data.layout;
    });
  };

  _proto.getAllLayouts = function getAllLayouts() {
    return this._httpClient.post('/v2/layouts/list', {
      layoutIds: []
    }).then(function (response) {
      return response.data.layouts;
    });
  };

  _proto.deleteLayout = function deleteLayout(layoutId) {
    return this._httpClient["delete"]('/v2/layouts/' + layoutId).then(function (response) {
      return response.data;
    });
  };

  _proto.createTemplate = function createTemplate(template, tags) {
    return this._httpClient.post('/v2/templates', {
      template: template,
      tags: tags
    }).then(function (response) {
      return response.data.templateId;
    });
  };

  _proto.getTemplate = function getTemplate(templateId) {
    return this._httpClient.get("/v2/templates/" + templateId).then(function (response) {
      return response.data.template;
    });
  };

  _proto.updateTemplate = function updateTemplate(template) {
    return this._httpClient.put('/v2/templates/' + template.id, {
      template: template
    }).then(function (response) {
      return response.data.template;
    });
  };

  _proto.tagZoeTemplate = function tagZoeTemplate(templateId, tags) {
    if (tags === void 0) {
      tags = [];
    }

    return this._httpClient.put('/v2/templates', {
      templateId: templateId,
      tags: tags
    }).then(function (response) {
      return response.data.template;
    });
  };

  _proto.deleteTemplate = function deleteTemplate(templateId) {
    return this._httpClient["delete"]('/v2/templates/' + templateId).then(function (response) {
      return response.data;
    });
  };

  _proto.getTaggedTemplate = function getTaggedTemplate(templateId) {
    return this._httpClient.get('/v2/templates/' + templateId + '/tags').then(function (response) {
      return response.data;
    });
  };

  _proto.getLogoTemplatesByTags = function getLogoTemplatesByTags(tags, industry, options) {
    if (options === void 0) {
      options = {};
    }

    var limit = options.limit || TEMPLATES_LIMIT;
    var shouldSuffle = typeof options.shouldSuffle === 'boolean' ? options.shouldSuffle : true;
    return this._httpClient.post("/v1/logo-templates/search?limit=" + limit + "&shouldShuffle=" + shouldSuffle, {
      industry: industry,
      characteristics: tags || []
    }).then(function (response) {
      return response.data;
    });
  };

  _proto.createZoeLogo = /*#__PURE__*/function () {
    var _createZoeLogo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(logo) {
      var _yield$this$_httpClie, logoId, previewUploadPath;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this._httpClient.post("/v2/logos", {
                logo: logo
              }).then(function (response) {
                return response.data;
              });

            case 2:
              _yield$this$_httpClie = _context.sent;
              logoId = _yield$this$_httpClie.id;
              previewUploadPath = _yield$this$_httpClie.previewUploadPath;
              return _context.abrupt("return", {
                logoId: logoId,
                previewUploadPath: previewUploadPath
              });

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function createZoeLogo(_x) {
      return _createZoeLogo.apply(this, arguments);
    }

    return createZoeLogo;
  }();

  _proto.saveZoeLogo = /*#__PURE__*/function () {
    var _saveZoeLogo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(logoId, logo) {
      var _yield$this$_httpClie2, responsePreviewUploadPath, responseLogoId;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              this._validateLogoId(logoId, 'saveZoeLogo');

              _context2.next = 3;
              return this._httpClient.put("/v2/logos/" + logoId, {
                logo: logo
              }).then(function (response) {
                var data = response.data;
                var previewUploadPath = data.previewUploadPath;
                return {
                  previewUploadPath: previewUploadPath,
                  logoId: logoId
                };
              });

            case 3:
              _yield$this$_httpClie2 = _context2.sent;
              responsePreviewUploadPath = _yield$this$_httpClie2.previewUploadPath;
              responseLogoId = _yield$this$_httpClie2.logoId;
              return _context2.abrupt("return", {
                previewUploadPath: responsePreviewUploadPath,
                logoId: responseLogoId
              });

            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function saveZoeLogo(_x2, _x3) {
      return _saveZoeLogo.apply(this, arguments);
    }

    return saveZoeLogo;
  }();

  _proto.getLogoCount = function getLogoCount() {
    return this._httpClient.get('/v1/logos/count').then(function (response) {
      return response.data;
    });
  };

  _proto.getSavedLogos = function getSavedLogos(from, to) {
    return this._httpClient.get('/v1/logos/draft', {
      params: {
        from: from,
        to: to
      }
    }).then(function (response) {
      return response.data;
    });
  };

  _proto.getPurchasedLogos = function getPurchasedLogos(from, to) {
    return this._httpClient.get('/v1/logos/purchased', {
      params: {
        from: from,
        to: to
      }
    }).then(function (response) {
      return response.data;
    });
  };

  _proto.getAllZoeLogos = function getAllZoeLogos() {
    return this._httpClient.get("/v3/logos").then(function (response) {
      return response.data;
    }).then(function (res) {
      return logoDisplaysTransformer(res.logoDisplays);
    });
  };

  _proto.getAllZoeLogosStep1 = function getAllZoeLogosStep1() {
    return this._httpClient.get("/v3/logos").then(function (response) {
      return response.data;
    });
  };

  _proto.getAllZoeLogosStep2 = function getAllZoeLogosStep2(zoeLogosRes) {
    return logoDisplaysTransformer(zoeLogosRes.logoDisplays);
  };

  _proto.getLogoById = function getLogoById(logoId) {
    return this._httpClient.get("/v1/logos/" + logoId).then(function (response) {
      return response.data;
    });
  };

  _proto.getBrand = function getBrand(brandId) {
    return this._httpClient.get("v1/admin/brand/" + brandId).then(function (response) {
      return response.data;
    });
  };

  _proto.listDesigns = function listDesigns(brandId) {
    return this._httpClient.get("v1/admin/brand/" + brandId + "/designs").then(function (response) {
      return response.data;
    });
  };

  _proto.setIsPrimaryLogoDownloaded = function setIsPrimaryLogoDownloaded(brandId, isPrimaryLogoDownloaded) {
    return this._httpClient.patch("v1/admin/brand/logo-downloaded/" + brandId, {
      brandId: brandId,
      isPrimaryLogoDownloaded: isPrimaryLogoDownloaded
    }).then(function (response) {
      return response.data;
    });
  };

  _proto.getLogoDisplayById = function getLogoDisplayById(logoId) {
    return this.get("/v1/logos/" + logoId + "/display").then(function (data) {
      return data.logoDisplay;
    });
  };

  _proto.getAssetsById = function getAssetsById(purchaseId) {
    return this._httpClient.post("/v1/purchased/" + purchaseId + "/assets", {}).then(function (response) {
      return response.data;
    }).then(function (data) {
      return data.logoAssets;
    });
  };

  _proto.saveCart = function saveCart(cartItems, logoId) {
    var params = {
      cart: {
        logoId: logoId,
        items: []
      }
    };
    cartItems.forEach(function (item, index) {
      params.cart.items[index] = {
        name: item
      };
    });
    return this._httpClient.post("/v1/carts/" + logoId, params).then(function (response) {
      return response.data;
    });
  };

  _proto.getCart = function getCart() {
    return this._httpClient.get("v1/carts", {
      // Fix weird behavior on back from premium
      headers: {
        'Cache-Control': 'no-cache,no-store,must-revalidate,max-age=-1,private'
      }
    }).then(function (response) {
      var logos = {};
      var logoCartArray = response.data.carts;
      logoCartArray.forEach(function (logoCartItem) {
        logos[logoCartItem.logoId] = {
          items: logoCartItem.items.map(function (x) {
            return x.name;
          })
        };
      });
      return {
        logos: logos
      };
    });
  };

  _proto.deleteLogoById = function deleteLogoById(logoId) {
    return this._httpClient["delete"]("/v1/logos/" + logoId).then(function (response) {
      return response.data;
    });
  };

  _proto.deleteZoeLogoById = function deleteZoeLogoById(logoId) {
    this._validateLogoId(logoId, 'deleteZoeLogoById');

    return this._httpClient["delete"]("/v2/logos/" + logoId).then(function (response) {
      return response.data;
    });
  };

  _proto.editLogoById = function editLogoById(logoId) {
    return this._httpClient.post("/v1/purchased/logos/" + logoId + "/edit", {}).then(function (response) {
      return response.data;
    });
  };

  _proto.editZoeLogoById = function editZoeLogoById(logoId, purchaseId) {
    this._validateLogoId(logoId, 'editZoeLogoById');

    return this._httpClient.post("/v1/purchased/" + purchaseId + "/logos/" + logoId + "/edit", {
      logoId: logoId,
      purchaseId: purchaseId,
      version: 2
    }).then(function (response) {
      return response.data;
    });
  };

  _proto.duplicateLogoById = function duplicateLogoById(logoId) {
    return this._httpClient.post("/v1/logos/" + logoId + "/duplicate", {}).then(function (response) {
      return response.data;
    });
  };

  _proto.getLogoSite = function getLogoSite(logoId) {
    return this._httpClient.get("/v1/logos/" + logoId + "/site").then(function (response) {
      return response.data;
    }).then(function (_ref) {
      var adiInstanceId = _ref.adiInstanceId,
          _ref$version = _ref.version,
          version = _ref$version === void 0 ? 1 : _ref$version,
          rest = _objectWithoutPropertiesLoose(_ref, _excluded3);

      return _objectSpread({
        instanceId: adiInstanceId,
        version: version
      }, rest);
    })["catch"](function () {
      return null;
    });
  };

  _proto.setLogoSite = function setLogoSite(logoId, _ref2, oldLogoSite, version, logoVersion) {
    var siteId = _ref2.siteId,
        metaSiteId = _ref2.metaSiteId,
        instanceId = _ref2.instanceId;

    if (logoVersion === void 0) {
      logoVersion = 1;
    }

    var params = {
      siteId: siteId,
      metaSiteId: metaSiteId,
      adiInstanceId: instanceId,
      version: version,
      logoVersion: logoVersion
    };

    if (oldLogoSite && oldLogoSite.metaSiteId) {
      params.oldMetaSiteId = oldLogoSite.metaSiteId;
    }

    return this._httpClient.post("/v1/logos/" + logoId + "/site", params).then(function (response) {
      return response.data;
    });
  };

  _proto.setBrandSite = function setBrandSite(brandId, metaSiteId) {
    var params = {
      brand_id: brandId,
      metaSiteId: metaSiteId
    };
    return this._httpClient.post("/v1/site/" + metaSiteId + "/brands", params).then(function (response) {
      return response.data;
    });
  };

  _proto.hideBrandSite = function hideBrandSite(_ref3) {
    var metasiteId = _ref3.metasiteId,
        _ref3$hideSite = _ref3.hideSite,
        hideSite = _ref3$hideSite === void 0 ? false : _ref3$hideSite;
    var params = {
      metasiteId: metasiteId,
      hideSite: hideSite
    };
    return this._httpClient.post("/v2/site/" + metasiteId + "/hide", params).then(function (response) {
      return response.data;
    });
  };

  _proto.claimLogoSite = function claimLogoSite(logoId, metaSiteId) {
    return this._httpClient.put("/v1/logos/" + logoId + "/site/" + metaSiteId + "/claim", {}).then(function (response) {
      return response.data;
    });
  };

  _proto.uploadSvg = /*#__PURE__*/function () {
    var _uploadSvg = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(svg, filePrefix, brand, createPreview, backgroundColor, retries) {
      var result, params, response;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (createPreview === void 0) {
                createPreview = false;
              }

              if (backgroundColor === void 0) {
                backgroundColor = undefined;
              }

              if (retries === void 0) {
                retries = 3;
              }

              params = {};

              if (createPreview) {
                params.createPreview = 'true';
              }

              _context3.prev = 5;
              _context3.next = 8;
              return this._httpClient.post("/v1/svg/upload", {
                svg: svg,
                filePrefix: filePrefix,
                brand: brand,
                backgroundColor: backgroundColor
              }, {
                params: params
              });

            case 8:
              response = _context3.sent;
              result = response.data;
              _context3.next = 23;
              break;

            case 12:
              _context3.prev = 12;
              _context3.t0 = _context3["catch"](5);

              if (!retries) {
                _context3.next = 22;
                break;
              }

              _context3.next = 17;
              return wait(200);

            case 17:
              _context3.next = 19;
              return this.uploadSvg(svg, filePrefix, brand, createPreview, backgroundColor, retries - 1);

            case 19:
              result = _context3.sent;
              _context3.next = 23;
              break;

            case 22:
              console.error("uploadSvg - " + filePrefix + " - failed with retires");

            case 23:
              return _context3.abrupt("return", result);

            case 24:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this, [[5, 12]]);
    }));

    function uploadSvg(_x4, _x5, _x6, _x7, _x8, _x9) {
      return _uploadSvg.apply(this, arguments);
    }

    return uploadSvg;
  }();

  _proto.downloadEditedLogo = function downloadEditedLogo(logoId, icon, mediaIds, previewMediaId, logoEditorData, logo) {
    var postData = {
      logoId: logoId,
      icon: icon,
      mediaIds: mediaIds,
      previewMediaId: previewMediaId,
      logo: logo
    };

    if (logoEditorData) {
      postData.logoEditorData = logoEditorData;
    }

    return this._httpClient.post("/v1/purchased/logos/" + logoId + "/download", postData).then(function (response) {
      return response.data;
    });
  };

  _proto.searchNounProjectIcons = function searchNounProjectIcons(term, limit, offset) {
    var searchParams = "?" + queryString.stringify({
      limit: limit,
      offset: offset
    });
    return this._httpClient.get(urlJoin('/v1/icons/search', term, searchParams)).then(function (response) {
      return response.data;
    });
  };

  _proto.fetchNounIconById = function fetchNounIconById(id) {
    return this._httpClient.get(urlJoin('/v1/icons', id)).then(function (response) {
      return response.data;
    });
  };

  _proto._searchIcons = function _searchIcons(body) {
    return this._httpClient.post('/v1/icons/search', body).then(function (response) {
      return response.data;
    })["catch"](function (e) {
      console.error("Error fetching icons", e, body);
      return {};
    });
  };

  _proto.searchNounProjectIconsAndWixCms = function searchNounProjectIconsAndWixCms(term, limit, pageNumber, sources) {
    var sourceToFetch = [{
      source: sources[0],
      searchTerm: term,
      pageSize: 100,
      pageNumber: pageNumber
    }, {
      source: sources[1],
      searchTerm: term,
      pageSize: 500,
      pageNumber: pageNumber
    }].filter(function (sourceItem) {
      return sources.includes(sourceItem.source);
    });
    var body = {
      iconSearchesOpts: sourceToFetch
    };
    return this._searchIcons(body);
  };

  _proto.searchIconBySource = function searchIconBySource(source, term, limit, pageNumber) {
    var sourceToFetch = [{
      source: source,
      searchTerm: term,
      pageSize: limit,
      pageNumber: pageNumber
    }];
    var body = {
      iconSearchesOpts: sourceToFetch
    };
    return this._searchIcons(body);
  };

  _proto.fetchNounAndWixCmsIconById = function fetchNounAndWixCmsIconById(id, source) {
    return this._httpClient.get(urlJoin('/v1/icons', id, "?source=" + source)).then(function (response) {
      return response.data;
    });
  };

  _proto.setLogosForWebsite = function setLogosForWebsite(logoIds, msid) {
    var _logoIds = castArray(logoIds);

    return this._httpClient.post("/v2/site/" + msid + "/logos", {
      logoIds: _logoIds
    }).then(function (res) {
      return res.data;
    });
  };

  _proto.getUserWebsiteZoeLogos = function getUserWebsiteZoeLogos(msid) {
    return this._httpClient.get("/v3/logos" + (msid ? "?logosFilter.metasiteId=" + msid : '')).then(function (res) {
      var logoDisplays = [];

      if (!res.data) {
        console.error("illegal msid " + msid);
      } else {
        logoDisplays = res.data.logoDisplays || [];
      }

      return logoDisplaysTransformer(logoDisplays);
    });
  };

  _proto.duplicateLogoForTouchUp = function duplicateLogoForTouchUp(_ref4) {
    var purchaseId = _ref4.purchaseId,
        logoId = _ref4.logoId,
        userId = _ref4.userId,
        previewUrl = _ref4.previewUrl;
    return this._httpClient.post("/v1/admin/duplicate/" + purchaseId, {
      purchaseId: purchaseId,
      logoId: logoId,
      originUserId: userId,
      previewUrl: previewUrl
    }).then(function (response) {
      return response.data;
    });
  };

  _proto.duplicateZoeLogoForTouchUp = function duplicateZoeLogoForTouchUp(_ref5) {
    var purchaseId = _ref5.purchaseId,
        logoId = _ref5.logoId,
        userId = _ref5.userId,
        previewUrl = _ref5.previewUrl,
        accountId = _ref5.accountId;
    return this._httpClient.post("/v2/admin/duplicate/" + purchaseId, {
      purchaseId: purchaseId,
      logoId: logoId,
      originUserId: userId,
      previewUrl: previewUrl,
      originAccountId: accountId
    }).then(function (response) {
      return response.data;
    });
  };

  _proto.getPendingTouchUps = function getPendingTouchUps() {
    return this._httpClient.get("/v1/admin/touch-ups").then(function (response) {
      return response.data.TouchUpLogoView;
    });
  };

  _proto.getPendingZoeTouchUps = function getPendingZoeTouchUps() {
    return this._httpClient.get("/v2/admin/touch-ups").then(function (response) {
      return response.data.TouchUpLogoView;
    });
  };

  _proto.transferAfterTouchUp = /*#__PURE__*/function () {
    var _transferAfterTouchUp = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref6) {
      var logoId, icon, previewUrl, mediaIds, logoEditorData;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              logoId = _ref6.logoId, icon = _ref6.icon, previewUrl = _ref6.previewUrl, mediaIds = _ref6.mediaIds, logoEditorData = _ref6.logoEditorData;
              _context4.next = 3;
              return this._httpClient.put("/v1/admin/transfer", {
                logoId: logoId,
                icon: icon,
                previewUrl: previewUrl,
                mediaIds: mediaIds,
                logoEditorData: logoEditorData
              }).then(function (response) {
                return response.data;
              });

            case 3:
              window.location.reload();

            case 4:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function transferAfterTouchUp(_x10) {
      return _transferAfterTouchUp.apply(this, arguments);
    }

    return transferAfterTouchUp;
  }();

  _proto.transferZoeLogoAfterTouchUp = /*#__PURE__*/function () {
    var _transferZoeLogoAfterTouchUp = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref7) {
      var logoId, previewUrl, mediaIds, logo;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              logoId = _ref7.logoId, previewUrl = _ref7.previewUrl, mediaIds = _ref7.mediaIds, logo = _ref7.logo;
              _context5.next = 3;
              return this._httpClient.put("/v2/admin/transfer", {
                logoId: logoId,
                previewUrl: previewUrl,
                mediaIds: mediaIds,
                logo: logo
              }).then(function (response) {
                return response.data;
              });

            case 3:
              window.location.reload();

            case 4:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, this);
    }));

    function transferZoeLogoAfterTouchUp(_x11) {
      return _transferZoeLogoAfterTouchUp.apply(this, arguments);
    }

    return transferZoeLogoAfterTouchUp;
  }();

  _proto.listTemplates = function listTemplates(tags, onlyPublished, page, limit) {
    if (tags === void 0) {
      tags = [];
    }

    if (onlyPublished === void 0) {
      onlyPublished = true;
    }

    if (page === void 0) {
      page = 0;
    }

    if (limit === void 0) {
      limit = 100;
    }

    var options = {
      limit: limit
    };
    var pagingParameters = ParameterBuilder.buildPagingParameters(page, options);
    var filterQuery = queryString.stringify({
      'filter.tags': tags,
      'filter.onlyPublished': onlyPublished
    });
    return this._httpClient.get("/v2/templates?" + filterQuery + "&" + pagingParameters).then(function (response) {
      return response.data.templates;
    });
  };

  _proto.getCategoryTypes = function getCategoryTypes() {
    return this._httpClient.get("v1/categories", {}).then(function (response) {
      return response.data;
    });
  };

  _proto.getAssetsByCategory = function getAssetsByCategory(category) {
    return this._httpClient.get("v1/assetTypes", {
      category: category
    }).then(function (response) {
      return response.data;
    });
  };

  _proto.getDimensionsByAssetType = function getDimensionsByAssetType(assetType) {
    return this._httpClient.get("v1/dimensions", {
      assetType: assetType
    }).then(function (response) {
      return response.data;
    });
  };

  _proto.getGalleryTemplateByGraphicId = /*#__PURE__*/function () {
    var _getGalleryTemplateByGraphicId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(graphicId) {
      var templates, matchingTemplate;
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return this.listGalleryTemplates();

            case 2:
              templates = _context6.sent;
              matchingTemplate = {};
              templates.forEach(function (template) {
                var graphics = template.graphicTemplates;
                graphics.forEach(function (graphicTemplate) {
                  if (graphicTemplate.id === graphicId) {
                    matchingTemplate = template;
                  }
                });
              });
              return _context6.abrupt("return", matchingTemplate);

            case 6:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, this);
    }));

    function getGalleryTemplateByGraphicId(_x12) {
      return _getGalleryTemplateByGraphicId.apply(this, arguments);
    }

    return getGalleryTemplateByGraphicId;
  }();

  _proto.listGalleryTemplates = function listGalleryTemplates(tags, onlyPublished, page) {
    if (tags === void 0) {
      tags = [];
    }

    if (onlyPublished === void 0) {
      onlyPublished = true;
    }

    if (page === void 0) {
      page = 0;
    }

    var pagingParameters = ParameterBuilder.buildPagingParameters(page);
    var filterQuery = queryString.stringify({
      'filter.tags': tags,
      'filter.onlyPublished': onlyPublished
    });
    return this._httpClient.get("/v2/gallery-templates?" + filterQuery + "&" + pagingParameters).then(function (response) {
      return response.data.templates;
    });
  };

  _proto.getGalleryTemplate = function getGalleryTemplate(templateId) {
    return this._httpClient.get("/v2/gallery-templates/" + templateId).then(function (response) {
      return response.data.template;
    });
  };

  _proto.updateGalleryTemplate = function updateGalleryTemplate(template) {
    return this._httpClient.put('/v2/gallery-templates/' + template.id, {
      template: template
    }).then(function (response) {
      return response.data.template;
    });
  };

  _proto.listLayouts = function listLayouts(layoutIds) {
    if (layoutIds === void 0) {
      layoutIds = [];
    }

    return this._httpClient.post("/v2/layouts/list", {
      layoutIds: layoutIds
    }).then(function (response) {
      return response.data.layouts;
    });
  };

  _proto.listAllTemplates = /*#__PURE__*/function () {
    var _listAllTemplates = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(page, tags, onlyPublished) {
      var finalTags, templates, templates2;
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              if (page === void 0) {
                page = 0;
              }

              // ** NOTE: Removed the tags to always send an empty list. Because we use them to filter and note sort! **
              finalTags = []; // tags

              _context7.next = 4;
              return this.listTemplates(finalTags, onlyPublished, page);

            case 4:
              templates = _context7.sent;

              if (!Array.isArray(templates)) {
                _context7.next = 11;
                break;
              }

              if (!(templates.length === 100)) {
                _context7.next = 11;
                break;
              }

              _context7.next = 9;
              return this.listAllTemplates(page + 1, finalTags, onlyPublished);

            case 9:
              templates2 = _context7.sent;

              if (Array.isArray(templates2)) {
                templates = [].concat(templates, templates2);
              }

            case 11:
              return _context7.abrupt("return", templates);

            case 12:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, this);
    }));

    function listAllTemplates(_x13, _x14, _x15) {
      return _listAllTemplates.apply(this, arguments);
    }

    return listAllTemplates;
  }();

  _proto.listAllGalleryTemplates = /*#__PURE__*/function () {
    var _listAllGalleryTemplates = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(page, tags, onlyPublished) {
      var graphicTemplates, graphicTemplatesById, templates;
      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              if (page === void 0) {
                page = 0;
              }

              graphicTemplates = [];
              graphicTemplatesById = [];
              _context8.next = 5;
              return this.listGalleryTemplates(tags, onlyPublished, page);

            case 5:
              templates = _context8.sent;
              templates.forEach(function (item) {
                var onlyLogos = [];
                item.graphicTemplates.forEach(function (graphic) {
                  onlyLogos.push(graphic.logo);
                });
                graphicTemplatesById[item.id] = onlyLogos; // TODO: should get the 1st?

                graphicTemplates.push(item.graphicTemplates[0]);
              });
              return _context8.abrupt("return", graphicTemplates);

            case 8:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, this);
    }));

    function listAllGalleryTemplates(_x16, _x17, _x18) {
      return _listAllGalleryTemplates.apply(this, arguments);
    }

    return listAllGalleryTemplates;
  }();

  _proto.listAllTemplatesAndLayouts = /*#__PURE__*/function () {
    var _listAllTemplatesAndLayouts = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(tags, onlyPublished, pagingParameters) {
      var templates, finalTags, limit, page, layoutIds, chunks, layouts, i, layoutIdsChunk, result;
      return _regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              templates = [];
              finalTags = [];

              if (!pagingParameters) {
                _context9.next = 9;
                break;
              }

              limit = pagingParameters.limit, page = pagingParameters.page;
              _context9.next = 6;
              return this.listTemplates(finalTags, onlyPublished, page, limit);

            case 6:
              templates = _context9.sent;
              _context9.next = 12;
              break;

            case 9:
              _context9.next = 11;
              return this.listAllTemplates(0, tags, onlyPublished);

            case 11:
              templates = _context9.sent;

            case 12:
              layoutIds = templates.map(function (template) {
                var layoutId = template.layoutId;
                return layoutId;
              });
              chunks = chunk(layoutIds, 100);
              layouts = [];
              i = 0;

            case 16:
              if (!(i < chunks.length)) {
                _context9.next = 25;
                break;
              }

              layoutIdsChunk = chunks[i];
              _context9.next = 20;
              return this.listLayouts(layoutIdsChunk);

            case 20:
              result = _context9.sent;
              layouts = [].concat(layouts, result);

            case 22:
              i++;
              _context9.next = 16;
              break;

            case 25:
              return _context9.abrupt("return", {
                templates: templates,
                layouts: layouts
              });

            case 26:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, this);
    }));

    function listAllTemplatesAndLayouts(_x19, _x20, _x21) {
      return _listAllTemplatesAndLayouts.apply(this, arguments);
    }

    return listAllTemplatesAndLayouts;
  }();

  _proto.getLayoutsForGalleryTemplate = /*#__PURE__*/function () {
    var _getLayoutsForGalleryTemplate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(templates) {
      var layoutIds, chunks, layouts, i, layoutIdsChunk, result;
      return _regeneratorRuntime.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              layoutIds = templates.map(function (template) {
                var layoutId = template.layoutId;
                return layoutId;
              });
              chunks = chunk(layoutIds, 100);
              layouts = [];
              i = 0;

            case 4:
              if (!(i < chunks.length)) {
                _context10.next = 13;
                break;
              }

              layoutIdsChunk = chunks[i];
              _context10.next = 8;
              return this.listLayouts(layoutIdsChunk);

            case 8:
              result = _context10.sent;
              layouts = [].concat(layouts, result);

            case 10:
              i++;
              _context10.next = 4;
              break;

            case 13:
              return _context10.abrupt("return", layouts);

            case 14:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10, this);
    }));

    function getLayoutsForGalleryTemplate(_x22) {
      return _getLayoutsForGalleryTemplate.apply(this, arguments);
    }

    return getLayoutsForGalleryTemplate;
  }();

  _proto.listAllGalleryTemplatesAndLayouts = /*#__PURE__*/function () {
    var _listAllGalleryTemplatesAndLayouts = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(tags, onlyPublished) {
      var templates, layoutIds, chunks, layouts, i, layoutIdsChunk, result;
      return _regeneratorRuntime.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return this.listAllGalleryTemplates(0, tags, onlyPublished);

            case 2:
              templates = _context11.sent;
              layoutIds = templates.map(function (template) {
                var layoutId = template.layoutId;
                return layoutId;
              });
              chunks = chunk(layoutIds, 100);
              layouts = [];
              i = 0;

            case 7:
              if (!(i < chunks.length)) {
                _context11.next = 16;
                break;
              }

              layoutIdsChunk = chunks[i];
              _context11.next = 11;
              return this.listLayouts(layoutIdsChunk);

            case 11:
              result = _context11.sent;
              layouts = [].concat(layouts, result);

            case 13:
              i++;
              _context11.next = 7;
              break;

            case 16:
              return _context11.abrupt("return", {
                templates: templates,
                layouts: layouts
              });

            case 17:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11, this);
    }));

    function listAllGalleryTemplatesAndLayouts(_x23, _x24) {
      return _listAllGalleryTemplatesAndLayouts.apply(this, arguments);
    }

    return listAllGalleryTemplatesAndLayouts;
  }();

  _proto.getDesignTemplateList = /*#__PURE__*/function () {
    var _getDesignTemplateList = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
      return _regeneratorRuntime.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              return _context12.abrupt("return", this._httpClient.get("v1/design/templates", {}).then(function (response) {
                return response.data;
              }));

            case 1:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12, this);
    }));

    function getDesignTemplateList() {
      return _getDesignTemplateList.apply(this, arguments);
    }

    return getDesignTemplateList;
  }();

  _proto.listBrandTemplates = function listBrandTemplates(params) {
    if (params === void 0) {
      params = {};
    }

    var _params = params,
        page = _params.page,
        filter = _params.filter,
        rest = _objectWithoutPropertiesLoose(_params, _excluded4);

    var pagingParameters = {};

    if (page) {
      pagingParameters = {
        page: ParameterBuilder.buildPagingParameters(page, {
          limit: DEFAULT_LOGOS_PER_PAGE
        })
      };
    }

    return this._httpClient.get("v1/design/templates", {
      params: _objectSpread(_objectSpread(_objectSpread({}, filter), rest), pagingParameters)
    }).then(function (response) {
      return response.data;
    });
  };

  _proto.getDesignTemplateById = /*#__PURE__*/function () {
    var _getDesignTemplateById = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(id) {
      var _yield$this$_httpClie3, designTemplate;

      return _regeneratorRuntime.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              _context13.next = 2;
              return this._httpClient.get("v1/design/templates/" + id, {}).then(function (response) {
                return response.data;
              });

            case 2:
              _yield$this$_httpClie3 = _context13.sent;
              designTemplate = _yield$this$_httpClie3.designTemplate;
              return _context13.abrupt("return", designTemplate);

            case 5:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee13, this);
    }));

    function getDesignTemplateById(_x25) {
      return _getDesignTemplateById.apply(this, arguments);
    }

    return getDesignTemplateById;
  }();

  _proto.updateDesignTemplate = /*#__PURE__*/function () {
    var _updateDesignTemplate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(designTemplate, id) {
      return _regeneratorRuntime.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              return _context14.abrupt("return", this._httpClient.put("v1/design/templates/" + id, {
                templateId: id,
                designTemplate: designTemplate
              }).then(function (response) {
                return response.data;
              }));

            case 1:
            case "end":
              return _context14.stop();
          }
        }
      }, _callee14, this);
    }));

    function updateDesignTemplate(_x26, _x27) {
      return _updateDesignTemplate.apply(this, arguments);
    }

    return updateDesignTemplate;
  }();

  _proto.deleteDesignTemplate = /*#__PURE__*/function () {
    var _deleteDesignTemplate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(id) {
      return _regeneratorRuntime.wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              return _context15.abrupt("return", this._httpClient["delete"]("v1/design/templates/" + id).then(function (response) {
                return response.data;
              }));

            case 1:
            case "end":
              return _context15.stop();
          }
        }
      }, _callee15, this);
    }));

    function deleteDesignTemplate(_x28) {
      return _deleteDesignTemplate.apply(this, arguments);
    }

    return deleteDesignTemplate;
  }();

  _proto.createNewDesignTemplate = /*#__PURE__*/function () {
    var _createNewDesignTemplate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(designTemplate) {
      return _regeneratorRuntime.wrap(function _callee16$(_context16) {
        while (1) {
          switch (_context16.prev = _context16.next) {
            case 0:
              return _context16.abrupt("return", this._httpClient.post("v1/design/templates", {
                designTemplate: designTemplate
              }).then(function (response) {
                return response.data;
              }));

            case 1:
            case "end":
              return _context16.stop();
          }
        }
      }, _callee16, this);
    }));

    function createNewDesignTemplate(_x29) {
      return _createNewDesignTemplate.apply(this, arguments);
    }

    return createNewDesignTemplate;
  }();

  _proto.getZoeLogoById = function getZoeLogoById(logoId) {
    this._validateLogoId(logoId, 'getZoeLogoById');

    return this._httpClient.get("/v2/logos/" + logoId).then(function (response) {
      return response.data;
    });
  };

  _proto.getPurchaseStatus = function getPurchaseStatus(purchaseId) {
    return this._httpClient.get("/v1/logo/purchase/" + purchaseId + "/status").then(function (res) {
      return res.data;
    })["catch"](function (e) {
      console.error(e);
      return null;
    });
  } // / TAGS - api v1
  ;

  _proto.getTaggedEntitiesForIndustry =
  /*#__PURE__*/
  function () {
    var _getTaggedEntitiesForIndustry = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(id, matchType) {
      var entities, _yield$Promise$all, paletteEntities, iconEntities;

      return _regeneratorRuntime.wrap(function _callee17$(_context17) {
        while (1) {
          switch (_context17.prev = _context17.next) {
            case 0:
              if (matchType === void 0) {
                matchType = 'EXACT';
              }

              entities = {};
              _context17.next = 4;
              return Promise.all([this.getTaggedEntitiesForIndustryByType(id, 'PALETTE', matchType), this.getTaggedEntitiesForIndustryByType(id, 'ICON', matchType)]);

            case 4:
              _yield$Promise$all = _context17.sent;
              paletteEntities = _yield$Promise$all[0].entities;
              iconEntities = _yield$Promise$all[1].entities;
              entities.paletteEntities = paletteEntities;
              entities.iconEntities = iconEntities;
              return _context17.abrupt("return", entities);

            case 10:
            case "end":
              return _context17.stop();
          }
        }
      }, _callee17, this);
    }));

    function getTaggedEntitiesForIndustry(_x30, _x31) {
      return _getTaggedEntitiesForIndustry.apply(this, arguments);
    }

    return getTaggedEntitiesForIndustry;
  }();

  _proto.getTaggedPaletteEntitiesForIndustry = /*#__PURE__*/function () {
    var _getTaggedPaletteEntitiesForIndustry = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(id, matchType) {
      var entities, _yield$Promise$all2, paletteEntities;

      return _regeneratorRuntime.wrap(function _callee18$(_context18) {
        while (1) {
          switch (_context18.prev = _context18.next) {
            case 0:
              if (matchType === void 0) {
                matchType = 'EXACT';
              }

              entities = {};
              _context18.next = 4;
              return Promise.all([this.getTaggedEntitiesForIndustryByType(id, 'PALETTE', matchType)]);

            case 4:
              _yield$Promise$all2 = _context18.sent;
              paletteEntities = _yield$Promise$all2[0].entities;
              entities.paletteEntities = paletteEntities;
              return _context18.abrupt("return", entities);

            case 8:
            case "end":
              return _context18.stop();
          }
        }
      }, _callee18, this);
    }));

    function getTaggedPaletteEntitiesForIndustry(_x32, _x33) {
      return _getTaggedPaletteEntitiesForIndustry.apply(this, arguments);
    }

    return getTaggedPaletteEntitiesForIndustry;
  }();

  _proto.getTaggedIconsEntitiesForIndustry = /*#__PURE__*/function () {
    var _getTaggedIconsEntitiesForIndustry = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19(id, matchType) {
      var entities, _yield$Promise$all3, iconEntities;

      return _regeneratorRuntime.wrap(function _callee19$(_context19) {
        while (1) {
          switch (_context19.prev = _context19.next) {
            case 0:
              if (matchType === void 0) {
                matchType = 'EXACT';
              }

              entities = {};
              _context19.next = 4;
              return Promise.all([this.getTaggedEntitiesForIndustryByType(id, 'ICON', matchType)]);

            case 4:
              _yield$Promise$all3 = _context19.sent;
              iconEntities = _yield$Promise$all3[0].entities;
              entities.iconEntities = iconEntities;
              return _context19.abrupt("return", entities);

            case 8:
            case "end":
              return _context19.stop();
          }
        }
      }, _callee19, this);
    }));

    function getTaggedIconsEntitiesForIndustry(_x34, _x35) {
      return _getTaggedIconsEntitiesForIndustry.apply(this, arguments);
    }

    return getTaggedIconsEntitiesForIndustry;
  }();

  _proto.getTaggedEntitiesForIndustryByType = function getTaggedEntitiesForIndustryByType(id, entityType, matchType, offset) {
    if (matchType === void 0) {
      matchType = 'EXACT';
    }

    if (offset === void 0) {
      offset = 0;
    }

    var searchParams = queryString.stringify({
      'page.limit': 100,
      'page.offset': offset
    });
    var filterQuery = queryString.stringify({
      'tagFilterType.industryFilter.externalIndustryId': id,
      'tagFilterType.industryFilter.matchType': matchType
    });
    return this._httpClient.get("/v1/tags?" + filterQuery + "&" + searchParams, {
      params: {
        type: entityType
      }
    }).then(function (response) {
      return response.data;
    });
  };

  _proto.createNewTag = function createNewTag(taggedEntity) {
    this._validateEntityId(taggedEntity.entityId, 'createNewTag');

    try {
      return this._httpClient.post('/v1/tags', {
        taggedEntity: taggedEntity
      }).then(function (response) {
        return response.data;
      });
    } catch (e) {
      console.error('Error - create new Tag failed ', e);
    }
  };

  _proto.deleteTag = /*#__PURE__*/function () {
    var _deleteTag = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20(tagId, entityId) {
      var encodedTagId;
      return _regeneratorRuntime.wrap(function _callee20$(_context20) {
        while (1) {
          switch (_context20.prev = _context20.next) {
            case 0:
              encodedTagId = tagId.split(' ').join('+');
              return _context20.abrupt("return", this._httpClient["delete"](urlJoin('/v1/tags', encodedTagId), {
                params: {
                  entityId: entityId
                }
              }).then(function (response) {
                return response.data;
              }));

            case 2:
            case "end":
              return _context20.stop();
          }
        }
      }, _callee20, this);
    }));

    function deleteTag(_x36, _x37) {
      return _deleteTag.apply(this, arguments);
    }

    return deleteTag;
  }();

  _proto.createNewIndustry = function createNewIndustry(industry) {
    return this._httpClient.post('/v1/industries', {
      industry: industry
    }).then(function (response) {
      return response.data;
    })["catch"](function (e) {
      console.error(e);
    });
  };

  _proto.updateIndustry = function updateIndustry(industryId, industry) {
    return this._httpClient.put(urlJoin('/v1/industries', industryId), {
      industry: industry
    }).then(function (response) {
      return response.data;
    });
  };

  _proto.deleteIndustry = function deleteIndustry(industryId) {
    return this._httpClient["delete"](urlJoin('/v1/industries', industryId)).then(function (response) {
      return response.data;
    });
  };

  _proto.listEntitiesOfType = function listEntitiesOfType(type, offset) {
    if (offset === void 0) {
      offset = 0;
    }

    var filterQuery = queryString.stringify({
      'page.limit': 100,
      'page.offset': offset
    });
    return this._httpClient.get("/v1/entities?" + filterQuery, {
      params: {
        types: type
      }
    }).then(function (response) {
      return response.data;
    });
  };

  _proto.listIndustries = function listIndustries() {
    return this._httpClient.get('/v1/industries').then(function (response) {
      return response.data;
    });
  };

  _proto.listPaletteEntities = function listPaletteEntities() {
    return this._httpClient.get('/v1/entities', {
      params: {
        types: 'PALETTE'
      }
    }).then(function (response) {
      return response.data;
    });
  };

  _proto.listFontEntities = function listFontEntities() {
    return this._httpClient.get('/v1/entities', {
      params: {
        types: 'FONT'
      }
    }).then(function (response) {
      return response.data;
    });
  };

  _proto.listTagQuantities = function listTagQuantities() {
    return this._httpClient.get('/v1/tags/quantities').then(function (response) {
      return response.data;
    });
  };

  _proto.createNewEntity = function createNewEntity(entity) {
    try {
      return this._httpClient.post('/v1/entities', {
        entity: entity
      }).then(function (response) {
        return response.data;
      })["catch"](function (e) {
        console.error(e);
      });
    } catch (e) {
      console.error('Error creating New Entity , ', e);
    }
  };

  _proto.deleteEntityById = function deleteEntityById(entityId) {
    return this._httpClient["delete"](urlJoin('/v1/entities', entityId)).then(function (response) {
      return response.data;
    });
  };

  _proto.updateEntityById = function updateEntityById(entityId, entity) {
    return this._httpClient.put(urlJoin('/v1/entities', entityId), {
      entity: entity
    }).then(function (response) {
      return response.data;
    });
  };

  _proto.getIconUrlByIdAndSource = function getIconUrlByIdAndSource(iconId, iconSource, assetId) {
    var _this$_options$should = this._options.shouldUseNewIconServer,
        shouldUseNewIconServer = _this$_options$should === void 0 ? false : _this$_options$should;
    var finalParams = assetId ? {
      assetId: assetId
    } : {};

    if (shouldUseNewIconServer) {
      return this.iconsUrlHttpClient.get("api/v1/icons/" + iconId + "/" + iconSource, {
        params: finalParams
      }).then(function (response) {
        return response.data;
      });
    } else {
      return this.get(urlJoin('/v1/icons', iconId, iconSource));
    }
  };

  _proto.getTagsByEntityId = function getTagsByEntityId(entityId, tagType) {
    return this._httpClient.get("/v1/tags/" + entityId, {
      params: {
        entityId: entityId,
        tagType: tagType
      }
    }).then(function (response) {
      return response.data;
    });
  };

  _proto.getEntityByExternalId = /*#__PURE__*/function () {
    var _getEntityByExternalId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21(type, externalId, offset) {
      var entityMatchExternalId, resultFromCache, _yield$this$listEntit, entities;

      return _regeneratorRuntime.wrap(function _callee21$(_context21) {
        while (1) {
          switch (_context21.prev = _context21.next) {
            case 0:
              if (offset === void 0) {
                offset = 0;
              }

              entityMatchExternalId = null;
              resultFromCache = this.entitiesCache.find(function (entity) {
                return entity.externalId === externalId;
              });

              if (!(resultFromCache !== undefined)) {
                _context21.next = 7;
                break;
              }

              return _context21.abrupt("return", resultFromCache);

            case 7:
              _context21.next = 9;
              return this.listEntitiesOfType(type, offset);

            case 9:
              _yield$this$listEntit = _context21.sent;
              entities = _yield$this$listEntit.entities;
              this.entitiesCache = [].concat(this.entitiesCache, entities);

              if (!(Array.isArray(entities) && entities.length > 0)) {
                _context21.next = 18;
                break;
              }

              entityMatchExternalId = entities.find(function (entity) {
                return entity.externalId === externalId;
              });

              if (entityMatchExternalId) {
                _context21.next = 18;
                break;
              }

              _context21.next = 17;
              return this.getEntityByExternalId(type, externalId, offset + DEFAULT_PAGE_LIMIT);

            case 17:
              entityMatchExternalId = _context21.sent;

            case 18:
              return _context21.abrupt("return", entityMatchExternalId);

            case 19:
            case "end":
              return _context21.stop();
          }
        }
      }, _callee21, this);
    }));

    function getEntityByExternalId(_x38, _x39, _x40) {
      return _getEntityByExternalId.apply(this, arguments);
    }

    return getEntityByExternalId;
  }();

  _proto.getProductsPricing = function getProductsPricing(products) {
    return this._httpClient.post('/v1/product-pricing', {
      products: products
    }).then(function (response) {
      return response.data;
    });
  };

  _proto.getPagedZoeLogos = /*#__PURE__*/function () {
    var _getPagedZoeLogos = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22(page, statuses) {
      var pagingParameters, logosFilterParams, concatParams, _yield$this$_httpClie4, logosByType;

      return _regeneratorRuntime.wrap(function _callee22$(_context22) {
        while (1) {
          switch (_context22.prev = _context22.next) {
            case 0:
              pagingParameters = ParameterBuilder.buildPagingParameters(page, {
                limit: DEFAULT_LOGOS_PER_PAGE
              });
              logosFilterParams = ParameterBuilder.buildLogosFilterParameters({
                statuses: statuses
              });
              concatParams = ParameterBuilder.concatParams(pagingParameters, logosFilterParams);
              _context22.next = 5;
              return this._httpClient.get("/v4/logos?" + concatParams).then(function (response) {
                return response.data;
              });

            case 5:
              _yield$this$_httpClie4 = _context22.sent;
              logosByType = _yield$this$_httpClie4.logosByType;
              Object.keys(logosByType).forEach(function (logoType) {
                logosByType[logoType].logoDisplays = logoDisplaysTransformer(logosByType[logoType].logoDisplays);
              });
              return _context22.abrupt("return", logosByType);

            case 9:
            case "end":
              return _context22.stop();
          }
        }
      }, _callee22, this);
    }));

    function getPagedZoeLogos(_x41, _x42) {
      return _getPagedZoeLogos.apply(this, arguments);
    }

    return getPagedZoeLogos;
  }();

  _proto.listCategories = function listCategories() {
    return this._httpClient.get('/v1/categories').then(function (response) {
      return response.data;
    });
  };

  return LogoWebAppApi;
}();